export default "/images/7aabe504c362a4cb2101460a18c83619.png";